module.exports = __webpack_public_path__ + "static/img/1.51d6610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail0/1.png
// module id = 3blG
// module chunks = 15